import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.338 8.667H.69q.083-.396.177-.792S1.895 2.957 6.343 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646q.091.378.17.758M.682 23.333H31.31a30 30 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a26 26 0 0 1-.184-.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M13.686 21.537c.196-.105.419-.19.642-.203h.062c.675 0 .862.574 1.33.62s.86-.576 1.441-.599c.31-.012.665.133.927.272A6 6 0 0 1 16 22a6 6 0 0 1-2.314-.463m-2.27-1.665c.183-.116.368-.205.518-.205.433 0 .83.626 1.282.667s.723-.626 1.32-.626c.596 0 .94.606 1.409.606s.958-.564 1.427-.585c.47-.02.94.605 1.356.585.415-.021.776-.606 1.283-.626.19.019.386.095.56.198q-.36.425-.795.777l-7.59-.031a6 6 0 0 1-.77-.76m9.574-.539H19s.456-.36.58-.694c.229.167.167.333.623.361s.89-.692 1.326-.666q-.223.529-.54 1m-10.515-.989c.415.088.831.681 1.265.656.478-.028.413-.194.652-.36.13.332.608.693.608.693h-1.99a6 6 0 0 1-.535-.989m4.527.99c-.033 0 .385-.972.999-.997.551-.074 1.014.97.999.994z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M10.21 14.419q.178-.648.487-1.23L14 15.668v.13zm-.14.658 3.93 1.43v.16h-3.963a6 6 0 0 1 .033-1.59m1.73-3.362 2.2 2.828v.29l-2.956-2.216q.335-.489.756-.902m.502-.44A6 6 0 0 1 14 10.34v3.116zm9.488 3.144L18 15.797v-.13l3.302-2.477q.31.58.488 1.229m.14.658a6 6 0 0 1 .033 1.59H18v-.16zm-1.73-3.362q.42.413.756.902L18 14.833v-.29zm-.502-.44L18 13.457v-3.116c.619.22 1.19.536 1.698.934",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M13.167 12.667H12.5v4.916a1.417 1.417 0 0 0 2.833.017 1.25 1.25 0 0 1-2.166-.85zm5.5 0h.666v4.916a1.417 1.417 0 0 1-2.833.017 1.25 1.25 0 0 0 2.167-.85zm-1.5-2.474V10a2.5 2.5 0 0 0-2.5 2.5v2.333l2.5.834V12.14q-.121.026-.25.027c-.599 0-1.084-.448-1.084-1 0-.553.485-1 1.083-1q.13 0 .25.026",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagPyf = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagPyf_default = SvgFlagPyf;

export { FlagPyf_default as default };
